import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface NavItem {
  id: string;
  label: string;
  icon: string;
  path: string;
  requireAuth?: boolean;
  badge?: number;
}

export function BottomNavigation() {
  const location = useLocation();
  const { user } = useAuth();

  const navItems: NavItem[] = [
    {
      id: 'home',
      label: 'Αρχική',
      icon: '🏠',
      path: '/'
    },
    {
      id: 'cases',
      label: 'Περιστατικά',
      icon: '📋',
      path: '/cases'
    },
    {
      id: 'create',
      label: 'Δημιουργία',
      icon: '➕',
      path: '/cases/new',
      requireAuth: true
    },
    {
      id: 'forum',
      label: 'Forum',
      icon: '💬',
      path: '/forum'
    },
    {
      id: 'profile',
      label: user ? 'Προφίλ' : 'Σύνδεση',
      icon: user ? '👤' : '🔐',
      path: user ? '/profile' : '/login'
    }
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // Don't show on certain pages
  const hideOnPaths = ['/login', '/register'];
  if (hideOnPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <>
      {/* Spacer to prevent content from being hidden behind bottom nav */}
      <div className="h-16 md:hidden" />
      
      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden z-50">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const active = isActive(item.path);
            
            // Hide auth-required items for non-authenticated users
            if (item.requireAuth && !user) {
              return null;
            }

            return (
              <Link
                key={item.id}
                to={item.path}
                className={`flex flex-col items-center justify-center flex-1 py-2 px-1 transition-colors duration-150 ${
                  active
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <div className="relative">
                  <span className="text-lg mb-1 block">{item.icon}</span>
                  {item.badge && item.badge > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {item.badge > 9 ? '9+' : item.badge}
                    </span>
                  )}
                </div>
                <span className={`text-xs font-medium ${active ? 'text-blue-600' : 'text-gray-600'}`}>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}